export default {
    maintenanceServicesToComplete_title: "Complete for ",
    maintenanceServicesToComplete_selectServiceComplete: "Select the service to complete:"
}